/*
 * /api/checkout/:path will be redirect to process.env.NEXT_PUBLIC_SCAYLE_CHECKOUT_API_ENDPOINT/:path
 * Customer API (checkout) docs https://scayle.dev/api/oauth/latest
 * */
import { GENDER } from '../constants';

export enum CheckoutApiUrls {
  BASE_CHECKOUT_API = '/api/checkout',
  DELETE_COOKIES = '/api/delete-cookies',
  GET_CUSTOMER = `${BASE_CHECKOUT_API}/oauth/me`,
  GET_CUSTOMER_ORDER = `${BASE_CHECKOUT_API}/oauth/customer/order`,
  CREATE_ADDRESS = `${BASE_CHECKOUT_API}/oauth/customer/address`,
  GET_ADDRESSES = `${BASE_CHECKOUT_API}/oauth/customer/addresses`,
  UPDATE_PERSONAL_DATA = `${BASE_CHECKOUT_API}/oauth/customer/personal`,
  UPDATE_PASSWORD = `${BASE_CHECKOUT_API}/oauth/customer/password`,
  UPDATE_EMAIL = `${BASE_CHECKOUT_API}/oauth/customer/email`,
  UPDATE_CUSTOM_DATA = `${BASE_CHECKOUT_API}/oauth/customer/custom-data`,
}

interface IRecipient {
  firstName: string;
  gender: GENDER;
  lastName: string;
}
export interface IAddress {
  isBillingAddress: boolean;
  isShippingAddress: boolean;
  zipCode: string;
  city: string;
  countryCode: string;
  street: string;
  houseNumber: string;
  additional: string;
  id: number;
  recipient: IRecipient;
  email?: string;
}

export interface IUpdateAddress
  extends Pick<
    IAddress,
    'city' | 'street' | 'zipCode' | 'additional' | 'countryCode'
  > {}
